
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import progressGif from "../images/progress.gif"; 

function Fps() {
  const [districts, setDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [selectedDistrictCode, setSelectedDistrictCode] = useState('');
  const [afsoList, setAfsoList] = useState([]);
  const [selectedAfso, setSelectedAfso] = useState('');
  const [fpsIds, setFpsIds] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [inputState, setInputState] = useState({});
  const [statusMessage, setStatusMessage] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_URL}/api/districts`, { withCredentials: true })
      .then(response => setDistricts(response.data || []))
      .catch(error => console.error('Error fetching districts:', error));
  }, []);

  useEffect(() => {
    if (!selectedDistrictCode) return;

    setLoading(true);
    axios.get(`${process.env.REACT_APP_URL}/api/officeName?distCode=${selectedDistrictCode}`, { withCredentials: true })
      .then(res => {
        setAfsoList(res.data || []);
        setSelectedAfso('');
        setFpsIds([]);
      })
      .catch(err => {
        console.error(err);
        setAfsoList([]);
      })
      .finally(() => setLoading(false));
  }, [selectedDistrictCode]);

  const fetchFpsData = async () => {
    if (!selectedDistrictCode || !selectedAfso) {
      alert("Please select District and Office");
      return;
    }

    setLoading(true);
    setShowTable(false);
    setStatusMessage('');

    try {
      const response = await axios.get(`${process.env.REACT_APP_URL}/api/fpsIdByDistAfso?distCode=${selectedDistrictCode}&afsoCode=${selectedAfso}`, { withCredentials: true });
      const data = response.data || [];

      if (data.length === 0) {
        setFpsIds([]);
        setStatusMessage("No Data Found");
      } else {
        setInputState(data.reduce((acc, fps, index) => ({
          ...acc,
          [`grainATM_${index}`]: fps.grainAtmStatus === "G",
          [`fpsWeighing_${index}`]: fps.weighingStatus === "Y",
        }), {}));
        setFpsIds(data);
        setShowTable(true);
      }
    } catch (error) {
      console.error(error);
      setFpsIds([]);
      setStatusMessage('Error fetching FPS data');
    } finally {
      setLoading(false);
    }
  };

  const handleDistrictChange = (e) => {
    const code = e.target.value;
    setSelectedDistrictCode(code);
    const name = districts.find(d => d.distCode === code)?.distNameEn || '';
    setSelectedDistrict(name);
    setSelectedAfso('');
    setAfsoList([]);
    setFpsIds([]);
    setShowTable(false);
    setStatusMessage('');
  };

  const handleAfsoChange = (e) => {
    setSelectedAfso(e.target.value);
    setFpsIds([]);
    setShowTable(false);
    setStatusMessage('');
  };
const toggleDisableField = async (field, index) => {
  const currentState = inputState[`${field}_${index}`]; 
  const newState = !currentState;                       
  const fpsId = fpsIds[index].fpsId;

  setInputState(prev => ({ ...prev, [`${field}_${index}`]: undefined }));

  try {
    const grainAtmStatus = field === "grainATM" ? (newState ? "G" : "N") : (inputState[`grainATM_${index}`] ? "G" : "N");
    const weighingStatus = field === "fpsWeighing" ? (newState ? "Y" : "N") : (inputState[`fpsWeighing_${index}`] ? "Y" : "N");

    await axios.post(
      `${process.env.REACT_APP_URL}/api/updateStatus`,
      { fpsId, grainAtmStatus, weighingStatus },
      { withCredentials: true }
    );

    setInputState(prev => ({ ...prev, [`${field}_${index}`]: newState }));

    const action = newState ? "Enabled" : "Disabled";
    setStatusMessage(`FPS ID ${fpsId}: ${field === "grainATM" ? "Grain ATM" : "FPS Weighing"} ${action} successfully.`);
  } catch (error) {
    console.error(`Error updating ${field}:`, error);
    setStatusMessage(`FPS ID ${fpsId}: Update failed.`);
    setInputState(prev => ({ ...prev, [`${field}_${index}`]: currentState }));
  }
};

  const buttonStyle = (isEnabled) => ({
    backgroundColor: isEnabled ? 'red' : 'green',
    color: 'white',
    border: 'none',
    padding: '5px 10px',
    cursor: 'pointer',
    borderRadius: '5px',
  });

  return (
    <div className="wrapper row3">
      <div id="container">
        <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
          <table width="50%">
            <thead>
              <tr className="tableheader">
                <th colSpan={2}>FPS WISE WEIGHING</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <td align="center">District</td>
                <td align="left" style={{ width: '45%' }}>
                  <select value={selectedDistrictCode} onChange={handleDistrictChange} style={{ width: '80%', padding: '5px' }}>
                    <option value="">Select District</option>
                    {districts.map((dist, index) => (
                      <option key={index} value={dist.distCode}>{dist.distNameEn}</option>
                    ))}
                  </select>
                </td>

                <td align="center">Office</td>
                <td align="left" style={{ width: '45%' }}>
                  <select
                    value={selectedAfso}
                    onChange={handleAfsoChange}
                    style={{ width: '80%', padding: '5px' }}
                    disabled={!selectedDistrictCode}
                  >
                    <option value="">Select Office</option>
                    {afsoList.length > 0
                      ? afsoList.map((afso, index) => (
                          <option key={index} value={afso.afsoCode}>{afso.afsoNameEn}</option>
                        ))
                      : <option disabled>No AFSO found</option>}
                  </select>
                </td>
              </tr>
              <tr>
                <td colSpan={4} align="center" style={{ paddingTop: '10px' }}>
                  <button onClick={fetchFpsData} className="button button2" style={{ marginRight: '10px' }}>Submit</button>
                  <button className="button button2" onClick={() => window.history.back()}>Back</button>
                </td>
              </tr>
            </tbody>
          </table>

          {loading && (
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <img src={progressGif} alt="Loading..." width="250" height="15" />
            </div>
          )}

          {!loading && statusMessage && !showTable && (
            <div style={{ marginTop: '30px', fontWeight: 'bold', textAlign: 'center', fontSize: '20px', color: 'darkred' }}>
              {statusMessage}
            </div>
          )}

          {!loading && showTable && (
            <table width="60%" border="1" style={{ borderCollapse: 'collapse', marginTop: '50px' }}>
              <thead>
                <tr className="tableheader">
                  <th colSpan={4}>FPS Wise Weighing Status</th>
                </tr>
                <tr style={{ backgroundColor: 'black', color: 'white' }}>
                  <th>S No</th>
                  <th>FPS Id</th>
                  <th>Grain ATM</th>
                  <th>FPS WEIGHING</th>
                </tr>
              </thead>
              <tbody>
                {fpsIds.map((fps, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{fps.fpsId}</td>
                    <td style={{ textAlign: 'center' }}>
                      <button 
                        onClick={() => toggleDisableField('grainATM', index)} 
                        style={buttonStyle(inputState[`grainATM_${index}`])}
                        disabled={inputState[`grainATM_${index}`] === undefined}
                      >
                        {inputState[`grainATM_${index}`] ? 'Disable' : 'Enable'}
                      </button>
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      <button 
                        onClick={() => toggleDisableField('fpsWeighing', index)} 
                        style={buttonStyle(inputState[`fpsWeighing_${index}`])}
                        disabled={inputState[`fpsWeighing_${index}`] === undefined}
                      >
                        {inputState[`fpsWeighing_${index}`] ? 'Disable' : 'Enable'}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {!loading && statusMessage && showTable && (
            <div style={{ marginTop: '30px', fontWeight: 'bold', textAlign: 'center', fontSize: '20px', color: 'green' }}>
              {statusMessage}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Fps;